import { gql } from '@apollo/client';
import { FileFragment } from 'graphql/File/fragments/FileFragment';
/**
 * @const ExportSaleItemVariantOptionRelationsMutation
 * @since 1.0.0
 */
export const ExportSaleItemVariantOptionRelationsMutation = gql `
  mutation ExportSaleItemVariantOptionRelationsMutation($input: ExportSaleItemVariantOptionRelationsInput!) {
    exportSaleItemVariantOptionRelations(input: $input) {
      ...FileFragment
    }
  }

  ${FileFragment}
`;
